import { Button, ButtonProps } from "@mui/material";

import { classNames } from "~/utils/utils";

interface IExternalButtonLink extends ButtonProps {
	link: string;
	label: string;
	className?: string;
}

export default function ExternalButtonLink({
	link = "",
	label = "button title",
	className = "",
	...props
}: IExternalButtonLink) {
	function onClick() {
		window.open(link);
	}

	return <Button color="success" variant="contained" onClick={onClick} className={classNames(["externalButtonLink", className])} {...props}>
		{ label }
	</Button>;
}
